import { ALL_FEAT_KEYS, FeatureKey } from "./allFeatures";

export const ALL_KEYS = ALL_FEAT_KEYS;

export const isFeatureAllowed = (key: FeatureKey): boolean => {
  if (key.includes("__")) {
    const page = key.split("__")[1];
    if (
      key in (window.lsComponentList || {}) &&
      window.location.pathname.includes(page)
    ) {
      return true;
    } else {
      return false;
    }
  }
  return key in (window.lsComponentList || {}) || false;
};

export const getFeatureValues = (key: FeatureKey) => {
  if (key.includes("__")) {
    const page = key.split("__")[1];
    if (
      key in (window.lsComponentList || {}) &&
      window.location.pathname.includes(page)
    ) {
      return (((window.lsComponentList || {}) as Record<string, any>) || {})[
        key
      ];
    } else {
      return {};
    }
  }
  return ((window.lsComponentList || {}) as Record<string, any>)[key] || {};
};
